import { type Modules } from 'mini-usercustomproperties/lib/schema/Modules';

export enum UserActivityKeys {
    mailboxCreationDate = 'mailboxCreationDate',
    miniFirstLogonDate = 'miniFirstLogonDate',
    userMonthlyActivity = 'userMonthlyActivity',
    userWeeklyActivity = 'userWeeklyActivity',
}

export interface UserCohortData {
    [UserActivityKeys.mailboxCreationDate]: string;
    [UserActivityKeys.miniFirstLogonDate]: string;
    [UserActivityKeys.userMonthlyActivity]: UserCohortActivity;
    [UserActivityKeys.userWeeklyActivity]: UserCohortActivity;
}

export interface UserActivity {
    // Timestamp
    [key: string]: {
        // ActionName
        [k: string]: number | undefined;
    };
}
export interface UserCohortActivity {
    [key: string]: UserActivity;
}

export function createDefaultUserCohortActivity(): UserCohortActivity {
    const activity: UserCohortActivity = {} as UserCohortActivity;
    const modules: Modules[] = ['mail', 'calendar', 'people', 'search'];
    for (const module of modules) {
        activity[module] = {};
    }
    return activity;
}
